module.exports = __webpack_public_path__ + "static/media/loader.f1e9daf5.webp";